var _circle, _circle2, _circle3, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTargetSavingsAct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 7.5,
    stroke: "#00896B",
    strokeWidth: 1.66667
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 5,
    stroke: "#00896B",
    strokeWidth: 1.66667
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 1.66667,
    stroke: "#00896B",
    strokeWidth: 1.66667
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 1.66667L11.6667 8.33334",
    stroke: "#E4F7F3",
    strokeWidth: 3.33333,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 3.33333L11.6667 8.33333",
    stroke: "#00896B",
    strokeWidth: 1.66667,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 1.66667V4.16667H18.3333",
    stroke: "#00896B",
    strokeWidth: 1.66667,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetSavingsAct);
export default __webpack_public_path__ + "static/media/TargetSavingsAct.3f99eec0d2026d9ce529409fcc9f0c96.svg";
export { ForwardRef as ReactComponent };